import React, { useEffect, useState } from 'react'
import { useTestimonialStore } from '../../store/useTestimonialStore';
import Loader from '../../Components/Loader';
import { Box, Button, Modal, Pagination, Stack, Typography } from '@mui/material';
import { Link } from 'react-router';
import TruncatedText from '../../Components/TruncatedText';

const TestimonialDisplay = () => {
    const [pageSize, setPageSize] = useState(10);
    const [totalPages, setTotalPages] = useState(1);
    const [pageNumber, setPageNumber] = useState(1);
    const [search, setSearch] = useState('');
    const [field, setField] = useState('title');
    const [loading, setLoading] = useState('');
    const [itemId, setItemId] = useState('');
    const [open, setOpen] = useState('');

    const { getTestimonialPage, testimonial, deleteTestimonial } = useTestimonialStore()

    const getTestimonialdata = async () => {
        setLoading(true)
        let res = await getTestimonialPage(pageNumber, pageSize, search, field)
        if (res) {
            setTotalPages(res?.totalPages);
        }
        setLoading(false)
    }

    const handleDelete = (id) => {
        setItemId(id)
        setOpen(true)
    }

    const handleCancelDelete = () => {
        setOpen(false);
    };

    const handleChangePagination = (event, value) => {
        setPageNumber(value);
    };

    const handleConfirmDelete = async () => {
        try {
            setOpen(false)
            setLoading(true)
            const res = await deleteTestimonial(itemId)
            setLoading(false)
        } catch (error) {
            setLoading(false)
            console.log(error)
        }
    }

    useEffect(() => {
        getTestimonialdata()
    }, [pageNumber, search, field])
    return (
        <div>
            <div className="bg-white rounded-md shadow-sm border border-neutral-200 overflow-hidden">
                <div className="px-6 py-4 border-b border-neutral-200 bg-neutral-50 flex justify-between items-center">
                    <h3>Testimonial Area</h3>
                    <div className="flex justify-end space-x-2">
                        <Link
                            to="/testimonial/form"
                            className="px-4 py-2 bg-neutral-900 text-white rounded-md"
                        >
                            <i className="fa-solid fa-plus mr-2"></i>
                            Add Testimonial
                        </Link>
                    </div>
                </div>
                <Loader loading={loading}>
                    <table className="w-full">
                        <thead>
                            <tr className="bg-neutral-50 text-center text-xs text-neutral-500 uppercase tracking-wider">
                                <th className="px-6 py-3">Name</th>
                                <th className="px-6 py-3">Designation</th>
                                <th className="px-6 py-3 w-[50%]">Comment</th>
                                <th className="px-6 py-3">Rating</th>
                                <th className="px-6 py-3">Status</th>
                                <th className="px-6 py-3">Order</th>
                                <th className="px-6 py-3 text-right">Actions</th>
                            </tr>
                        </thead>

                        <tbody className="divide-y divide-neutral-200 text-center">
                            {
                                (testimonial || []).map((ele, i) => {
                                    return (
                                        <tr className="hover:bg-neutral-50" key={i}>
                                            <td className="px-6 py-4">
                                                <div className="flex items-center">
                                                    {/* <div class="w-10 h-10  flex items-center justify-center rounded-sm text-white text-xs mr-3">
                                                        <img src={ele?.avatar} alt="" className='rounded-sm' />
                                                    </div> */}
                                                    <span>{ele?.name}</span>
                                                </div>
                                            </td>
                                            <td>
                                                {ele?.designation}
                                            </td>
                                            <td className="px-6 py-4 text-sm text-neutral-600 w-[50%]">
                                                <TruncatedText text={ele?.comment} limit={50} />
                                            </td>
                                            <td className="px-6 py-4 text-sm text-neutral-600 ">
                                                {ele?.rating}
                                            </td>
                                            <td>
                                                <span style={{ color: ele?.isFeatured ? 'green' : 'red' }}>
                                                    {ele?.isFeatured ? 'Active' : 'In Active'}
                                                </span>
                                            </td>
                                            <td>
                                                {ele?.order}
                                            </td>
                                            <td className="px-6 py-4 text-right text-sm">
                                                <Link
                                                    class="text-neutral-500 hover:text-neutral-700 mr-3"
                                                    to={`/testimonial/form?id=${ele?._id}`}
                                                >
                                                    <i className="fa-solid fa-edit"></i>
                                                </Link>
                                                <button
                                                    className="text-neutral-500 hover:text-neutral-600"
                                                    onClick={() => handleDelete(ele?._id)}
                                                >
                                                    <i className="fa-solid fa-trash-alt"></i>
                                                </button>
                                            </td>
                                        </tr>
                                    )
                                })
                            }

                        </tbody>
                    </table>
                </Loader>

            </div>

            <div className="flex justify-end items-center mb-6">
                <div className="flex justify-between items-center mb-6">
                    <Stack spacing={2} className="flex items-end mt-4">
                        <Pagination
                            count={totalPages}
                            onChange={handleChangePagination}
                            variant="outlined"
                            shape="rounded"
                            sx={{
                                "& .MuiPaginationItem-root": {
                                    color: "white",
                                    borderColor: "#000",
                                    backgroundColor: "#000",
                                },
                                "& .Mui-selected": {
                                    backgroundColor: "#333 !important",
                                    color: "white",
                                },
                                "& .MuiPaginationItem-root:hover": {
                                    backgroundColor: "#444",
                                    color: "white",
                                },
                            }}
                        />
                    </Stack>
                </div>
            </div>

            <Modal
                open={open}
                onClose={handleCancelDelete}
                aria-labelledby="confirm-delete-modal"
                aria-describedby="modal-to-confirm-deletion"
            >
                <Box
                    sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        backgroundColor: 'white',
                        padding: '20px',
                        borderRadius: '5px',
                        boxShadow: 24,
                        width: { xs: "80%", md: "500px" },
                        textAlign: 'center',
                    }}
                >
                    <Typography variant="h6" gutterBottom>
                        Are you sure you want to delete this Testimonial?
                    </Typography>
                    <Button variant="outlined" color="#274156" onClick={handleConfirmDelete}>
                        Yes
                    </Button>
                    <Button variant="outlined" color="#274156" onClick={handleCancelDelete} sx={{ marginLeft: '10px' }}>
                        No
                    </Button>
                </Box>
            </Modal>
        </div>
    )
}

export default TestimonialDisplay
